import { render, staticRenderFns } from "./ParteView.vue?vue&type=template&id=07a39988&scoped=true&"
import script from "./ParteView.vue?vue&type=script&lang=js&"
export * from "./ParteView.vue?vue&type=script&lang=js&"
import style0 from "./ParteView.vue?vue&type=style&index=0&id=07a39988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a39988",
  null
  
)

export default component.exports